import { render, staticRenderFns } from "./Proposal.vue?vue&type=template&id=74bc62b8&scoped=true&"
import script from "./Proposal.vue?vue&type=script&lang=ts&"
export * from "./Proposal.vue?vue&type=script&lang=ts&"
import style0 from "./Proposal.vue?vue&type=style&index=0&id=74bc62b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bc62b8",
  null
  
)

component.options.__file = "Proposal.vue"
export default component.exports